export const getValueAsArray = (params: any, key: string): any[] => {
    const value = params[key];

    return typeof value === 'string' ? [value] : value;
};
